import { VStack, Box } from '@chakra-ui/react';
import React from 'react';
import { QuoteProductDocument } from '../../../../../../../../types/Quotes';
import useOffer from '../../../store/offer/useOffer';
import OfferDocuments from '../offer-result/OfferDocuments';
import OfferBenefits from './extra-info/OfferBenefits';

interface Props {
  documents?: QuoteProductDocument[];
}

const OfferExtraInfo: React.FC<Props> = ({ documents }) => {
  const { offer, isLoading } = useOffer();
  return (
    <VStack align="stretch" spacing="6">
      {offer.details?.warnings.length && (
        <OfferBenefits benefits={offer.details?.warnings} />
      )}
      <Box
        display={{
          base: 'block',
        }}
      >
        <OfferDocuments
          documents={documents}
          offer={offer}
          isLoading={isLoading}
        />
      </Box>
    </VStack>
  );
};

export default OfferExtraInfo;
